import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/il8n/', '.json?v=' + new Date());
}

import { AppService } from './services/app.service';
import { BaseService } from './services/base.service';
import { ApiService } from './services/api.service';

import { AppRoutingModule, AuthGuard } from './app-routing.module';

import { AppComponent } from './app.component';
import { LogoComponent } from './components/common/logo/logo.component';
import { FormComponent } from './components/common/form/form.component';
import { TermsComponent } from './components/common/terms/terms.component';
import { SummaryComponent } from './components/common/summary/summary.component';
import { TypeComponent } from './components/common/type/type.component';

import { OfferComponent } from './components/offer/offer.component';
import { RegisterComponent } from './components/register/register.component';
import { IncorrectComponent } from './components/incorrect/incorrect.component';
import { EndedComponent } from './components/ended/ended.component';
import { IneligibleComponent } from './components/ineligible/ineligible.component';
import { ErrorComponent } from './components/error/error.component';
import { EnrolledComponent } from './components/enrolled/enrolled.component';

@NgModule({
  declarations: [
    AppComponent,

    LogoComponent,
    SummaryComponent,
    FormComponent,
    TermsComponent,
    TypeComponent,

    RegisterComponent,
    OfferComponent,
    IncorrectComponent,
    EndedComponent,
    IneligibleComponent,
    ErrorComponent,
    EnrolledComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,

    RecaptchaModule,
    RecaptchaFormsModule,

    HttpClientModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    AppRoutingModule
  ],
  providers: [DatePipe, DecimalPipe, AppService, BaseService, ApiService, AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }
